import translations from "./translations.json";

export const LANGUAGE_STORAGE_KEY = "titik-senyap-language";
export const stripLanguage = path => path.replace(/^\/en(?=\/|$)/, "") || "/";
export const localizedPath = (path, language) => {
  if (/^(https?:|#)/.test(path)) return path;
  const base = stripLanguage(path);
  return language === "en" ? `/en${base === "/" ? "" : base}` : base;
};
export function translate(text, language) {
  if (typeof text !== "string") return text;
  const key = text.replace(/\s+/g, " ").trim();
  return translations[key]?.[language] || text;
}

export function initialLanguage(path, fallback = "id") {
  if (/^\/en(?:\/|$)/.test(path)) return "en";
  if (typeof window === "undefined") return fallback;
  try { return window.localStorage.getItem(LANGUAGE_STORAGE_KEY) === "en" ? "en" : "id"; }
  catch { return "id"; }
}
